import request from '@/utils/request'

// 发布动态配置 检索
export function pubDynamicSearch(data) {
  return request({
    url: '/Index/search',
    method: 'post',
    data
  })
}

// RelatedLinks 检索
export function findRelatedLinks(data) {
  return request({
    url: '/Index/findRelatedLinks',
    method: 'post',
    data
  })
}

// 首页轮播图查询信息
export function findMovies(data) {
  return request({
    url: '/Index/findMovies',
    method: 'post',
    data
  })
}

// 首页查询统计信息
export function dataStatistics(data) {
  return request({
    url: '/Index/dataStatistics',
    method: 'post',
    data
  })
}

// 访问信息入库
export function saveVisits(data) {
  return request({
    url: '/Index/saveVisits',
    method: 'post',
    data
  })
}

// 查询用户信息
export function getUserInfo(data) {
  return request({
    url: 'web/service/user/info.htm',
    method: 'get',
    params: data
  })
}

// logout登出
export function logout(data) {
  return request({
    url: '/web/service/user/logout.htm',
    method: 'get',
    params: data
  })
}

// 获取登录跳转接口参数
export function getIp(data) {
  return request({
    url: '/web/service/param/find.htm',
    method: 'get',
    params: data
  })
}

// 获取登录跳转地址
export function getLoginUrl(data) {
  return request({
    url: '/web/service/param/find.htm',
    method: 'post',
    params: data
  })
}





// WEBPACK FOOTER //
// ./src/api/home.js